var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCalendarstandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.956 3.5a1 1 0 0 1 1 1v1.725l.551.07a1.951 1.951 0 0 1 1.674 1.65c.619 4.2.712 7.053.002 11.293a1.92 1.92 0 0 1-1.475 1.556c-5.025 1.116-8.36 1-13.526-.038a1.93 1.93 0 0 1-1.508-1.477c-.962-4.426-.83-7.274-.005-11.408a1.953 1.953 0 0 1 1.677-1.552l.61-.073V4.5a1 1 0 1 1 2 0v1.537c2.862-.258 5.253-.273 8-.027V4.5a1 1 0 0 1 1-1zm-11.716 7c.1-.695.228-1.42.383-2.2 4.89-.604 8.004-.63 12.584-.027.116.79.213 1.524.287 2.227H5.24zm-.206 2c-.115 1.964.055 3.861.583 6.303 4.903.982 7.942 1.08 12.603.05.4-2.405.526-4.32.431-6.353H5.034z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarstandard);
export default __webpack_public_path__ + "static/media/ic-calendar standard.55f54b2cfcaa1fdb23981679edff0512.svg";
export { ForwardRef as ReactComponent };